import moment from "moment";
import { displayDateFormat } from "../../../utils/helpers";
import { resolveVoucherListRowId } from "../../../utils/dmsStandaloneListUtils";

export const storeColumns = ({ navigate }) => [
  {
    Header: "V.ID",
    accessor: "id",
    Cell: (props) => {
      const id = resolveVoucherListRowId(props?.row?.original);
      const allData = props?.row?.original;

      if (!id) {
        return <span>-</span>;
      }

      return (
        <div
          className="cursor-pointer underline underline-offset-4"
          style={{
            color: "blue",
            cursor: "pointer",
            pointerEvents: "auto",
            userSelect: "none"
          }}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            navigate(`/vouchers/${id}`, { state: allData });
          }}
        >
          {id}
        </div>
      );
    },
  },
  {
    Header: "Submit On",
    accessor: "submittedOn",
    Cell: (props) => {
      if (
        !props?.row?.original?.submittedOn &&
        !props?.row?.original?.createdOn
      ) {
        return "-";
      }
      return (
        <div>
          {moment(props?.row?.original?.submittedOn).format(displayDateFormat)}
          {/* {(props?.row?.original?.submittedOn || props?.row?.original?.createdOn)} */}
        </div>
      );
    },
  },
  {
    Header: "Amount (₹)",
    accessor: "amount",
    Cell: (rowData) => {
      const value = rowData?.row?.original?.amount;
      let amount;
      if (typeof value == "string") {
        amount = Number(value).toFixed(2);
      } else {
        amount = value;
      }
      return Number(amount).toFixed(2) || "-";
    },
  },
  {
    Header: "L1 Status",
    accessor: "l1_status",
    Cell: (props) => {
      const value = props?.row?.original?.L1?.status;
      if (!value) {
        return "-";
      }
      return (
        <div
          className={
            value === "Approved"
              ? "text-[var(--successGreen)]"
              : value === "Rejected"
              ? "text-[var(--textRed)]"
              : value === "Pending"
              ? "text-[var(--pendingYellow)]"
              : value === "Pending"
              ? "text-[var(--pendingYellow)]"
              : "text-[var(--pendingYellow)]"
          }
        >
          {value}
        </div>
      );
    },
  },
  {
    Header: "L2 Status",
    accessor: "l2_status",
    Cell: (props) => {
      const value = props?.row?.original?.L2?.status;
      if (!value) {
        return "-";
      }
      return (
        <div
          className={
            value === "Approved"
              ? "text-[var(--successGreen)]"
              : value === "Rejected"
              ? "text-[var(--textRed)]"
              : value === "Pending"
              ? "text-[var(--pendingYellow)]"
              : "text-[var(--pendingYellow)]"
          }
        >
          {value}
        </div>
      );
    },
  },
  {
    Header: "A/C Status",
    accessor: "ac_status",
    Cell: (props) => {
      const value = props?.row?.original?.L3?.status;
      if (!value) {
        return "-";
      }
      return (
        <div
          className={
            value === "Approved"
              ? "text-[var(--successGreen)]"
              : value === "Rejected"
              ? "text-[var(--textRed)]"
              : value === "Pending"
              ? "text-[var(--pendingYellow)]"
              : "text-[var(--pendingYellow)]"
          }
        >
          {value}
        </div>
      );
    },
  },
  {
    Header: "Approved Amount (₹)",
    accessor: "approved_amount",
    Cell: (props) => {
      const value = props?.row?.original?.L3?.approvedAmount
        ? Number(props?.row?.original?.L3?.approvedAmount).toFixed(2)
        : "-";
      return <div className={"text-[var(--successGreen)]"}>{value}</div>;
    },
  },
];

export const l1Columns = ({ extraColumns = [], userLabel = "L1" }) => [
  ...extraColumns,
  {
    Header: "Submit On",
    accessor: "submittedOn",
    Cell: (props) => {
      if (!props?.row?.original?.submittedOn) {
        return "-";
      }
      return (
        <div>
          {moment(props?.row?.original?.submittedOn).format(displayDateFormat)}
          {/* {props?.row?.original?.submittedOn} */}
        </div>
      );
    },
  },
  {
    Header: "Amount (₹)",
    accessor: "amount",
    Cell: (rowData) => {
      const value = rowData?.row?.original?.amount;
      let amount;
      if (typeof value == "string") {
        amount = Number(value).toFixed(2);
      } else {
        amount = value;
      }
      return amount ? Number(amount).toFixed(2) : "-";
    },
  },
  {
    Header: "Approved",
    accessor: "approved",
    Cell: (props) => {
      const value = props?.row?.original?.approvedAmount;
      if (!value) {
        return "-";
      }
      return (
        <div className={"text-[var(--successGreen)]"}>
          {value ? Number(value).toFixed(2) : "-"}
        </div>
      );
    },
  },
  {
    Header: "Pending",
    accessor: "pendingAmount",
    Cell: (props) => {
      const value = props?.row?.original?.pendingAmount;
      if (!value) {
        return "-";
      }
      return (
        <div className={"text-[var(--pendingYellow)]"}>
          {value ? Number(value).toFixed(2) : "-"}
        </div>
      );
    },
  },
  {
    Header: "Rejected",
    accessor: "rejectedAmount",
    Cell: (props) => {
      const value = props?.row?.original?.rejectedAmount;
      if (!value) {
        return "-";
      }
      return (
        <div className={"text-[var(--textRed)]"}>
          {value ? Number(value).toFixed(2) : "-"}
        </div>
      );
    },
  },
];
